module.exports = {"data":{"allBlogJson":null,"authorJson":{"name":"Mitch Robertson","slug":"blog/author/mitch-robertson","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/mitch-robertson"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/blog-author-mitch-robertson.json
// module id = 1367
// module chunks = 169076919976411